import { Injectable } from '@angular/core';
import { ViewSubjects } from '@sharedlib/common/permissions/types/Permissions';

import { HasPermissionGuard } from './has-permission.guard';

/**
 * Gates the Sheets routes on the same per-app view permission every other app uses.
 *
 * `sheetsView` is granted in `AccountPermissionService` from `subscriptionPlan.sheetsAppEnabled`,
 * exactly as `notesView` is from `notesAppEnabled`. Both routes previously carried a comment saying
 * there was "no Sheets equivalent until the backend knows the app exists" -- that stopped being
 * true once the flag and the subject landed, and without the guard an unentitled user could open
 * /sheets and watch every request come back 403.
 */
@Injectable({ providedIn: 'root' })
export class SheetsAppGuard extends HasPermissionGuard {
  constructor() {
    super('read', ViewSubjects.sheetsView);
  }
}
